import { TokenService } from "@/services/storage.service";
import { mapState } from "vuex";


export default {
 
    methods: {
       
        $replaceData(date) {
            return new Date(date.replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3"))
        },
        $DDMMYYYY(replacedData) {
            let month = new Date(
                null,
                replacedData.getMonth() + 1,
                null
            ).toLocaleDateString("en", { month: "2-digit" });
            let day = replacedData.getDate();
            let year = replacedData.getFullYear();
            let digitDay = day.toString().length === 1 ? "0" + day : day;
            return digitDay + "-" + month + "-" + year;
        },
        $YYYYMMDD(replacedData) {
            let month = new Date(
                null,
                replacedData.getMonth() + 1,
                null
            ).toLocaleDateString("en", { month: "2-digit" });
            let day = replacedData.getDate();
            let year = replacedData.getFullYear();
            let digitDay = day.toString().length === 1 ? "0" + day : day;
            return year + "-" + month + "-" + digitDay;
        },
        $getName(item) {
            for (let i in item) {
                if (this.$i18n.locale == 'ru') {
                    if (i.endsWith("Ru")) {
                        return item[i];
                    }
                } else if (this.$i18n.locale == 'lt') {
                    if (i.endsWith("Lt")) {
                        return item[i];
                    }
                } else if (this.$i18n.locale == 'uz') {
                    if (i.endsWith("Uz")) {
                        return item[i];
                    }
                } else {
                    return
                }
            }
        },
    },
    computed: {
        baseUrl() {
            return process.env.VUE_APP_ROOT_URL
        },
    }
}

